import { render } from "./CixDash.vue?vue&type=template&id=73c56e3c&scoped=true&ts=true"
import script from "./CixDash.vue?vue&type=script&lang=ts"
export * from "./CixDash.vue?vue&type=script&lang=ts"

import "./CixDash.vue?vue&type=style&index=0&id=73c56e3c&lang=scss&scoped=true"

import exportComponent from "/Users/edvardaskostkevicius/WebstormProjects/rv_frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73c56e3c"]])

export default __exports__